module.exports = __webpack_public_path__ + "img/2025-12-20e_3.a5222537.jpg";